<template>
  <div class="chaseDialog" v-if="showDialog">
    <el-dialog :close-on-click-modal="false" title="追分申请" :visible.sync="showDialog" width="500px">
      <el-form :model="DetailInfo" ref="chaseDialog" label-width="130px" size="mini">
        <div class="chaseDialog-main">
          <el-form-item label="订单ID：">{{info.id}}
          </el-form-item>
          <el-form-item label="充值金额：">{{info.amount}}
          </el-form-item>
          <el-form-item label="当前余额：">{{balance}}
          </el-form-item>
          <el-form-item label="追分金额：">{{info.amount}}
          </el-form-item>
          <!--<div class="chase-info-item">-->
            <!--<p style="margin-right: 22px;" class="title">备注：</p>-->
            <!--<el-input class="info" v-model="reason" type="textarea" placeholder="请输入备注信息"></el-input>-->
          <!--</div>-->

          <el-form-item label="备注：" prop="remark" :rules="[{ required: true, message: '备注信息不能为空'}]">
            <el-input type="textarea" :rows="4" v-model="DetailInfo.remark" placeholder="请输入备注信息..."></el-input>
          </el-form-item>

          <div class="btns">
            <el-button @click="close" type>取消</el-button>
            <el-button @click="submit" type="primary">确定</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { chaseAgencyRecharge,getAgencyDetail } from "@/api";
import {useVcode} from "../../utils/CommonJs";

export default {
  data() {
    return {
      showDialog: false,
      info: null,
      balance:0,
      DetailInfo: {}
    };
  },
  created() {
    //   if (this.id) {
    //     this.getDetail()
    //   }
  },
  methods: {
    close() {
      this.showDialog = false;
    },
    open(info) {
      this.info = info;
      this.showDialog = true;
      getAgencyDetail(info.agency_id).then(res=>{
        if(res.status == 0){
           this.balance = Number(res.data.balance) / 100
        }
      })
    },
    submit() {
      this.$refs.chaseDialog.validate(valid => {
        if (valid) {
      useVcode(this, () => {
            chaseAgencyRecharge(this.info.id,this.DetailInfo).then(res => {
              if (res.status === 0) {
                this.$message({ message:  `追分已提交。`, type: "success" });
                this.close();
                this.$emit("success");
              } else {
                this.$message({ message: "追分失败。", type: "error" });
                this.close();
              }
            });
      })
}
})
    }
  }
};
</script>

<style lang="scss" scoped>
.chaseDialog {
  .chaseDialog-main {
    padding: 0 30px;
  }
  .chase-info-item {
    display: flex;
    flex-wrap: nowrap;
  }
  .title {
    width: 90px;
    color: #222;
    vertical-align: top;
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>

